(function () {
    'use strict';

    angular.module('gallery')
        .directive('gallery', gallery);

    function gallery() {
        return {
            restrict: 'E',
            templateUrl: 'layout/galleryTemplate.html',
            scope: {
                listMaximized: '=',
                object: '=',
                onSuccess: '&'
            },
            controller: directiveController
        };
    }

    function directiveController($scope, dialogService, GalleryService, GalleryConfigService, KeypressService, $window, userService) {
        $scope.images = ['loading'];
        $scope.listenerIDs = [];
        $scope.current = 0;

        angular.element(document).ready(function () {
            document.querySelector('#gallery-upload-wrapper-drop').click();
            document.querySelector('#gallery-upload-wrapper-drop').focus();
        });

        activate();

        $scope.nextImage = function (event) {//go to next image
            $scope.current = ($scope.current + 1) % $scope.images.length;
            if (event != undefined) {
                $scope.$apply();
            }
        };

        $scope.prevImage = function (event) {//go to previous image
            $scope.current--;
            if ($scope.current < 0) {
                $scope.current = $scope.images.length + $scope.current;
            }
            if (event != undefined) {
                $scope.$apply();
            }
        };

        $scope.isCurrent = function (index) {//check if image is current
            return index === $scope.current;
        };

        $scope.selectImage = function (index) {//select an image
            $scope.current = index;
        };

        $scope.openImage = function (index) {//open image in new tab/window
            var wind = window.open('about:blank', '_blank');
            var img = new Image();
            img.src = $scope.images[index].url;
            wind.document.getElementsByTagName('body')[0].innerHTML = img.outerHTML;
        };

        $scope.removeImage = function (index) {//remove an image
            dialogService.confirm('Ar tikrai norite trinti nuotrauką?', null, 'Trinti')
                .then(function () {
                    var id = $scope.images[index].id;
                    $scope.images.splice(index, 1);
                    GalleryService.deleteImage(id, function () {
                        loadImages();
                        if ($scope.onSuccess) {
                            $scope.onSuccess();
                        }
                    }, function () {
                        dialogService.error('Įvyko klaida trinant nuotrauką.');
                    });
                });
        }

        $scope.onWindowResize = function () { //handle window resizing (make sure, that the image does not overflow under the floating list)
            var bottom = document.getElementById('gallery-bottom').getBoundingClientRect().bottom;
            document.getElementById('gallery-modal-dialog').style.height = window.innerHeight - 200 + 'px';
            if ($scope.listMaximized)
                bottom -= bottom * 0.25; //subtract the thumb container height
            else bottom -= 25; //bottom position - padding
            var imagedropBoxRect = document.getElementById('image-display').getBoundingClientRect();
            document.getElementById('image-display').style.maxHeight = (bottom - imagedropBoxRect.top - 20) + 'px';
        };

        $scope.galleryInit = function ()//initialize the gallery (load images, and call onWindowResize, after the structure of HTML has loaded)
        {
            $scope.onWindowResize();
        }
        angular.element($window).bind('resize', $scope.onWindowResize);//register the handler

        $scope.cleanUp = function () {//unregister all listeners
            angular.element($window).unbind('resize', $scope.onWindowResize);
            for (var i = 0; i < $scope.listenerIDs.length; i++)
                KeypressService.unregisterKeypressListener($scope.listenerIDs[i]);
            $scope.listenerIDs.splice(0, $scope.listenerIDs.length);
        };

        $scope.$watch('object', loadImages());
        $scope.$on('refreshGallery', loadImages);

        function activate() {
            //register listeners
            $scope.listenerIDs.push(KeypressService.registerKeypressListener(37, $scope.prevImage));
            $scope.listenerIDs.push(KeypressService.registerKeypressListener(39, $scope.nextImage));
        }

        function loadImages() {
            if ($scope.object && $scope.object.id) {
                GalleryService.getImages($scope.object.id, function (data) {
                    $scope.images = _.map(data, function (item) {
                        return {
                            url: 'data:' + item.format + ';base64, ' + item.content,
                            id: item.id,
                            createdByCurrentUser: item.createdByCurrentUser
                        };
                    });

                    $scope.object.nuotraukuKiekis = $scope.images.length;
                    $scope.onWindowResize();
                }, function () {
                    $scope.images.splice(0, $scope.images.length);
                    dialogService.error('Įvyko klaida kraunant nuotraukas iš duomenų bazės.');
                });
            } else {
                dialogService.error('Įvyko klaida inicijuojant galeriją.');
            }
        }

        $scope.$watch('files', function () {
            $scope.upload($scope.files);
        });

        $scope.upload = function (files) {  // ngf functions uploads file
            if (files && files.length) {
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    GalleryService.uploadImages($scope.object.id, $scope.inputElement, file, function () {
                        $scope.$broadcast('refreshGallery');
                        if ($scope.onSuccess) {
                            $scope.onSuccess();
                        }
                    });
                }
            }
        };

        $scope.canRemoveImage = function (image) {
            return image ? userService.canEditObject(image.createdByCurrentUser) : false;
        }
    }
})();
